import { ReactComponent as RemoveIcon } from '../../../components/Common/BootstrapIcons/close.svg';
import BespokeToggleButton from '../../Functions/Bespoke/BespokeToggleButton';
import ColumnDefinition from '../../../infrastructure/types/DataGrid/ColumnDefinition';
import CustomIcon from '../../Common/BootstrapIcons/Custom/CustomIcon';
import EditableText from '../../Common/EditableText/EditableText';
import AggregationFilter from '../../../types/report/AggregationFilter';
import iconTooltip from '../../Common/BootstrapIcons/Tooltip/IconTooltip';
import React from 'react';
import ComponentType from '../../../types/report/ComponentType';
import ComponentChangeLogIconAndAction from '../../Common/Modals/ComponentChangeLogModal/ComponentChangeLogIconAndAction';
import SelectList from '../../Common/SelectList/SelectList';
import ReportConfig from '../../../types/report/ReportConfig';

const getColumns = (
    onNameChange: (name: string, number: number) => void,
    onBusinessDescriptionChange: (businessDescription: string, number: number) => void,
    onBespokeToggleClick: (isBespoke: boolean, filter: AggregationFilter) => void,
    onRemoveClick: (number: number) => void,
    onAggegationChange: (aggregationNumber: number, filterNumber: number) => void,
    reorder: (dragNumber: number, dropNumber: number) => void,
    isReadOnly: boolean,
    componentType: ComponentType,
    reportConfig: ReportConfig
): ColumnDefinition<AggregationFilter>[] => {

    let aggregationOptions = reportConfig.aggregations.map(x => ({ value: `${x.number}`, text: x.name }));

    let columns: ColumnDefinition<AggregationFilter>[] = [
        {
            header: 'Filter Name',
            getContent: x => <EditableText disabled={isReadOnly} value={x.name} onChange={value => onNameChange(value, x.number)} multiline={true} />,
            width: '200px'
        },
        {
            header: 'Business Description',
            getContent: x => <EditableText disabled={isReadOnly} value={x.businessDescription} onChange={value => onBusinessDescriptionChange(value, x.number)} multiline={true} style={{ width: '100%', height: '60px' }} />
        },
        {
            header: 'Aggregation',
            getContent: x => 
                <SelectList
                    className="inline-select"
                    disabled={isReadOnly}
                    options={aggregationOptions}
                    value={`${x.aggregationNumber}`}
                    onChange={((value, _) => { onAggegationChange(parseInt(value), x.number); })} />,
            width: '200px'
        },
        {
            header: '',
            getContent: x =>
                <div className="display-flex justify-content-end">
                    {
                        !isReadOnly &&
                        <BespokeToggleButton
                            isBespoke={x.isBespoke}
                            onClick={isBespoke => onBespokeToggleClick(isBespoke, x)}
                            style={{ verticalAlign: 'top', width: '150px' }} />
                    }
                    <button
                        className="custom-icon-button"
                        onClick={() => onRemoveClick(x.number)}
                        disabled={isReadOnly}>
                        <CustomIcon icon={RemoveIcon} title={iconTooltip.remove} />
                    </button>
                    {x.id &&
                        <ComponentChangeLogIconAndAction
                            reportConfigId={reportConfig.id as number}
                            id={x.id as number}
                            componentName={x.name}
                            componentType={componentType} />
                    }
                </div>,
            width: '200px'
        }
    ];

    return columns;
};

export {
    getColumns
};